import React from 'react';
import {Container,Row,CardDeck,CardGroup, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Team = (props) => {
    const{strTeamBadge,strTeam,strSport,idTeam} =props.team
    return (
 
        <Card className="col-sm-12 col-md-3  mx-4 my-3  "  style={{float:'left',backgroundColor:'#1167B1',marginTop:'10px',borderRadius:'20px',boxShadow:'5px 5px 10px grey'  }} >
        <Card.Img variant="top" src= {strTeamBadge} style={{padding:'20px'}}/>
        <Card.Body>
          <Card.Title style={{textAlign:'center',color:'white'}}>{strTeam}</Card.Title>
          <Card.Text  style={{textAlign:'center',color:'white'}}>Sports Type: {strSport}</Card.Text  >
          <Link to={`/team/${idTeam}`}>
          <Button  variant="success btn-block " className="justify-content-center align-items-center"  style={{color:'white',textAlign:'center'}}>Explore</Button></Link>
        </Card.Body>
      </Card>
      
      
    );
};

export default Team;